import { render, staticRenderFns } from "./SwitchPriceOptionStatus.vue?vue&type=template&id=a486861c&"
import script from "./SwitchPriceOptionStatus.vue?vue&type=script&lang=js&"
export * from "./SwitchPriceOptionStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports